import { render, staticRenderFns } from "./myheader.vue?vue&type=template&id=e42b494c&scoped=true"
import script from "./myheader.vue?vue&type=script&lang=js"
export * from "./myheader.vue?vue&type=script&lang=js"
import style0 from "./myheader.vue?vue&type=style&index=0&id=e42b494c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42b494c",
  null
  
)

export default component.exports